<blockquote id="home_top" xmlns="http://www.w3.org/1999/html"></blockquote>

<!-- region no carousel -->
<div *ngIf="!this.homeCarousel">
  <div class="image-container">
    <img [src]="'assets/banners/1.png'" class="img-fluid d-md-block d-lg-block d-xl-block">
    <div class="link-overlay">
      <div class="mt-3 mb-3">
        <a target="_blank" class="text-center mr-3" [href]="configurationService.home.urlAndroidStore">
          <img [src]="'assets/images/store_android.png'" class="store-banner" alt="android">
        </a>
        <a target="_blank" class="text-center" [href]="configurationService.home.urlAndroidStore">
          <img [src]="'assets/images/store_ios.png'" class="store-banner" alt="ios">
        </a>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <p class="mr-2">{{ "shered.footer.find-us" | translate: {Default:"Encuéntranos"} }}</p>
        <a href='{{facebook}}' target="_blank" class="social-icons mr-3"><i class="fab fa-facebook-f fa-lg"></i></a>
        <a href='{{instagram}}' target="_blank" class="social-icons mr-3"><i class="fab fa-instagram fa-lg"></i></a>
        <a href='{{tiktok}}' target="_blank" class="social-icons mr-3"><i class="fab fa-tiktok fa-lg"></i></a>
        <a href='{{twitter}}' target="_blank" class="social-icons mr-3"><i class="fab fa-twitter fa-lg"></i></a>
        <a href='{{youtube}}' target="_blank" class="social-icons mr-3"><i class="fab fa-youtube fa-lg"></i></a>
        <a href='{{linkedin}}' target="_blank" class="social-icons"><i class="fab fa-linkedin fa-lg"></i></a>
      </div>
    </div>
  </div>
  <div>
    <br>
  </div>

  <div>
    <div class="col-12 d-flex flex-column flex-md-row flex-lg-row flex-xl-row justify-content-center cards-container">
      <div class="col-12 col-md-4 col-lg-4 mb-4 mb-md-0 mb-lg-0 d-flex justify-content-center">
        <img [src]="'../../../assets/images/card1.png'" class="img-fluid rounded img-cards" id="img-1">
      </div>
      <div class="col-12 col-md-4 col-lg-4 mb-4 mb-md-0 mb-lg-0 d-flex justify-content-center">
        <img [src]="'../../../assets/images/card2.png'" class="img-fluid rounded img-cards">
      </div>
      <div class="col-12 col-md-4 col-lg-4 mb-md-0 mb-lg-0 d-flex justify-content-center">
        <img [src]="'../../../assets/images/card3.png'" class="img-fluid rounded img-cards" id="img-2">
      </div>
    </div>
  </div>
</div>

<!-- endregion no carousel -->

<!-- region carousel -->
<div *ngIf="this.homeCarousel">
  <div id="home_carousel" class="carousel slide" data-bs-ride="carousel">
    <ol class="carousel-indicators">
      <li data-bs-target="#home_carousel" data-bs-slide-to="0" class="active"></li>
      <li data-bs-target="#home_carousel" data-bs-slide-to="1"></li>
      <li data-bs-target="#home_carousel" data-bs-slide-to="2"></li>
    </ol>
    <div class="carousel-inner">
      <div class="app-carousel-bg carousel-item active" [ngStyle]="{'background-image': 'url(assets/banners/1_blur.png)'}" data-bs-interval="5000">
        <img [src]="'assets/banners/1.png'" class="d-block w-100 img-inner-center app-carousel-image" alt="1">
        <div class="d-none d-md-block">
          <div class="carousel-caption d-none d-md-block">
            <h1 class="mb-3 text-uppercase">{{ "home.banner1" | translate: {program: programName} }}</h1>
            <h4 class="mb-1"><b>{{ "home.banner_cero" | translate }}</b> {{ "home.banner1_info1" | translate }} <span style="font-size:0.7em;vertical-align:super;">*</span></h4>
            <p class="mb-1 small disclaimer-text"><span style="font-size:0.7em;vertical-align:super;">*</span>{{ "home.banner1_info1_disclaimer" | translate }}</p>
            <h4 class="mb-1"><b>{{ "home.banner_cero" | translate }}</b> {{ "home.banner1_info2" | translate }}</h4>
          </div>
        </div>
      </div>

      <div class="app-carousel-bg carousel-item" [ngStyle]="{'background-image': 'url(assets/banners/2_blur.png)'}" data-bs-interval="5000">
        <img [src]="'assets/banners/2.jpg'" class="d-block w-100 img-inner-center app-carousel-image" alt="2">
        <div class="d-none d-md-block">
          <div class="carousel-caption d-none d-md-block">
            <h1 class="text-uppercase translate-new-line">{{ "home.banner2" | translate }}</h1>
          </div>
        </div>
      </div>

      <div class="app-carousel-bg carousel-item" [ngStyle]="{'background-image': 'url(assets/banners/3_blur.png)'}" data-bs-interval="5000">
        <img [src]="'assets/banners/3.jpg'" class="d-block w-100 img-inner-center app-carousel-image" alt="3">
        <div class="d-none d-md-block">
          <div class="carousel-caption d-none d-md-block">
            <h1 class="mb-1 text-uppercase">{{ "home.banner3" | translate }}</h1>
            <h4>{{ "home.banner3_info1" | translate }}</h4>
            <a class="btn btn-primary btn-lg pl-5 pr-5" [attr.href]="'../../../assets/documents/DDAform.pdf'" download>{{ "home.banner3_info2" | translate }}</a>
          </div>
        </div>
      </div>
    </div>

    <section class="carousel-control-prev" type="button" data-bs-target="#home_carousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    </section>
    <section class="carousel-control-next" type="button" data-bs-target="#home_carousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
    </section>
  </div>
</div>
<!-- END region carousel -->


<div class="container" [ngClass]="this.homeCarousel ? 'mb-5' : ''">

  <div>
    <br>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">

        <div class="col-12 col-md-4 mb-sm-3">
          <div class="card h-100 text-center landingPageActions">
            <div class="card-body justify-content-center">
              <img [src]="'assets/images/iconos1.png'" class=" pt-2 pb-2 pr-5 pl-5 img-fluid">
              <h5 class="card-title font-weight-bold">{{ "landing.actionSection.getAccountElement1" | translate }}</h5>
              <p class="card-text">{{ "landing.actionSection.accountStepsElement1" | translate }}</p>
              <p class="card-text">{{ "landing.actionSection.registryProcessElement1" | translate }}</p>
              <div class="row justify-content-center">
                <div class="col-10 mb-2">
                  <a target="_blank" class="text-center" [href]="configurationService.home.urlAndroidStore">
                    <img [src]="'../../../assets/images/store_android.png'" class="storeImage" alt="android">
                  </a>
                </div>
                <div class="col-10">
                  <a target="_blank" class="text-center" [href]="configurationService.home.urlIosStore">
                    <img [src]="'../../../assets/images/store_ios.png'" class="storeImage" alt="ios">
                  </a>
                </div>
              </div>
            </div>
                <div *ngIf="configurationService.application.onboardingEnable && !deviceService.isMobile()" class="card-footer p-0">
              <a class="btn btn-rectangle btn-text-big btn-block text-white btn-primary" (click)="onboardingPath()"><p class="card-text">{{ "landing.actionSection.getAccountElement1" | translate }}</p></a>
            </div>
                <div *ngIf="!configurationService.application.onboardingEnable || deviceService.isMobile()" class="card-footer p-0 bg-primary" style="height: 40px">
            </div>
          </div>
        </div>

        <div id="targetElement" class="col-12 col-md-4  mb-sm-3 rounded">
          <div class="card h-100 landingPageActions">
            <div class="card-body text-center">
              <img [src]="'assets/images/iconos2.png'" class=" pt-2 pb-2 pr-5 pl-5 img-fluid">
              <h5 class="card-title font-weight-bold">{{ "landing.actionSection.depositCashElement2" | translate }}</h5>
              <p class="card-text">{{ "landing.actionSection.addCashElement2" | translate }}</p>
              <p class="card-text">{{ "landing.actionSection.handCashElement2" | translate }}</p>
              <p class="card-text font-italic italic-size-element2">{{ "landing.actionSection.feeElement2" | translate }}</p>
            </div>

            <div class="card-footer p-0">
              <button class="btn btn-rectangle btn-text-big btn-block btn-primary" (click)="openModal(modal_bahooPortals); webPage = 'https://secure.attheregister.com/locations'">{{ "landing.actionSection.findLocationElement2" | translate }}</button>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-4  mb-sm-3" (click)="openDepositForm()">
          <div class="card h-100 landingPageActions">
            <div class="card-body text-center">
              <img [src]="'assets/images/iconos3.png'" class=" pt-2 pb-2 pr-5 pl-5 img-fluid">

              <h5 class="card-title font-weight-bold">{{ "landing.actionSection.depositSalaryElement3" | translate }}</h5>
              <p class="card-text">{{ "landing.actionSection.depositSalaryPart2Element3" | translate }}</p>
              <p class="card-text">{{ "landing.actionSection.fillFormElement3" | translate }}</p>
              <p class="card-text font-italic italic-size-element3">{{ "landing.actionSection.downloadElement3" | translate }}</p>
            </div>
            <div class="card-footer p-0">
              <button class="btn btn-rectangle btn-text-big btn-block btn-primary">{{ "landing.actionSection.directDeposit3" | translate }}</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="container mb-5">
  <div class="row">
    <div class="col">
      <div class="row justify-content-center">
        <!--div class="col-md-12 col-lg-6 col-xl-6">
          <div class="card h-100">
            <img [src]="'assets/images/5.png'" class="card-img-top" alt="...">

            <div class="card-body">
              <h4 *ngIf="!this.guatemalan" class="card-title">{{ "home.card1" | translate: {program: programName} }}</h4>
              <h4 *ngIf="this.guatemalan" class="card-title">{{ "home.card1_guatemala" | translate: {program: programName} }}</h4>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>{{ "home.card1_info1" | translate }}</li>
                <li *ngIf="!this.guatemalan"><span class="fa-li"><i class="fas fa-check text-success"></i></span>{{ "home.card1_info2" | translate }}</li>
                <li *ngIf="this.guatemalan"><span class="fa-li"><i class="fas fa-check text-success"></i></span>{{ "home.card1_info2_guatemala" | translate }}</li>
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>{{ "home.card1_info3" | translate }}</li>
              </ul>
            </div>
          </div>
        </div-->

        <div class="col-md-12 col-lg-6 col-xl-6 mt-sm-3 mt-md-3 mt-lg-0">
          <div class="card h-100">
            <img [src]="'assets/images/4.png'" class="card-img-top" alt="...">

            <div class="card-body">
              <h4 class="card-title">{{ "home.card2" | translate: {program: programName} }}</h4>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet1" | translate: {program: this.productName} }}
                </li>
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet2" | translate }}
                </li>
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet3" | translate }}
                </li>
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet4" | translate }}
                </li>
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet5" | translate }}
                </li>
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet6" | translate }}
                </li>
                <!--li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet7" | translate }}
                </li-->
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet8" | translate }}
                </li>
                <li><span class="fa-li"><i class="fas fa-check text-success"></i></span>
                  {{ "landing.productDescription.bullet9" | translate }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container mb-5" id="linksContainer">

  <div class="row">
    <div class="col">
      <div class="row">

        <div class="col-md-12 col-lg-12 col-xl-12">
          <div class="card h-100">
            <div class="card-body text-center">
              <img [src]="'assets/logos/logo_bahu_processing.png'" class="card-img-top" alt="..." id="cardImg">
            </div>
            <div class="card-body text-center">
              <button class="btn btn-block btn-primary" (click)="openModal(modal_bahooPortals); webPage = bahuProcessingHost">{{ "home.go" | translate }}</button>
            </div>
          </div>
        </div>

        <blockquote id="contact-us" class="m-5"></blockquote>

      </div>
    </div>
  </div>

</div>

<!-- <blockquote id="contact-us" class="m-5"></blockquote> -->

<blockquote class="blockquote background-img text-center footerSpace"
  [ngStyle]="{
    'background-image': 'url(assets/images/background.png)',
    'min-height': namespace === 'cashingo' ? '30em' : 'auto'
  }">
  <div class="container-fluid">
    <div class="row" [style.color]="contactUsTextColor">
      <div class="col-12 col-md-6 pt-5 pb-5 text-center">
        <h2>{{ "home.contact_us" | translate }}</h2>
      </div>
      <div class="col-12 col-md-6">
        <app-contact-us [textColor]="contactUsTextColor"></app-contact-us>
      </div>
    </div>
  </div>
</blockquote>

<ng-template #modal_bahooPortals let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ "home.modal_bahu_portals.title" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ "home.modal_bahu_portals.privacy_policy" | translate }}</p>
  </div>
  <div class="modal-footer">
    <div class="btn-group">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close(); webPage = null">{{ "home.modal_bahu_portals.cancel" | translate }}</button>
      <a class="btn btn-primary" [href]="webPage" target="_blank">{{ "home.modal_bahu_portals.accept" | translate }}</a>
    </div>
  </div>
</ng-template>
